module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fb516154e603365f64d22b89fc08b8f8.png";